<template>
    <div class="instance-item">
        <ns-loader
            ref="ns-loader"
            :toLoad="toLoad"
            @dataFetched="onDataFetched"
            style="position: initial;"
        >
            <div slot="loader">
                <v-progress-circular
                    indeterminate
                    color="white"
                ></v-progress-circular>
            </div>
            <template slot="content">
                <div v-if="instance">
                    <div
                        v-if="relatedDeploymentRequestStatus === 'FAILED'"
                        class="instance-bullet info red accent-2"
                        @click.stop="openModalInstanceDeployFailed = true"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon  v-on="on">error_outline</v-icon>
                            </template>
                            <span>{{$t('instance.instance_list.instance_item.click_details')}}</span>
                        </v-tooltip>
                    </div>

                    <v-container
                        class="container-no-spaces"
                    >
                        <v-row >
                            <v-col
                                cols="12"
                                md="2"
                            >
                                <v-row>
                                    <v-col
                                        cols="3"
                                        md="2"
                                        sm="2"
                                    >
                                        <v-btn
                                            class="square-instance"
                                            :color="application.color"
                                        >
                                            <div class="instance-btn-content" style="text-transform: lowercase;">
                                                v{{ instance.current_modelisation.version }}
                                            </div>
                                        </v-btn>
                                        <div
                                            v-if="instanceStatus === 'STOPPED' && displayDeleteBtn"
                                            class="delete-btn btn-instances"
                                            @click="showModalArchive"                                    >
                                            <v-icon small right class="app-delete-icon">delete</v-icon>
                                        </div>
                                    </v-col>
                                    <v-col
                                        v-if="displayInstanceToColumn"
                                        cols="9"
                                        md="10"
                                        sm="10"
                                        align-self="center"
                                    >
                                        <div class="instance-status"> {{ getInstanceDeploymentStatus}} </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                cols="12"
                                md="10"
                                class="instance-right-content"
                            >
                                <div>
                                    <div style="display: inline-flex; align-items: baseline" :style="{opacity: relatedDeploymentRequestIsRunning ? 0.25 : 1}">
                                        <div class="instance-label">{{ instance.label }}</div>
                                        <div 
                                            
                                            class="instance-status-container"
                                        >
                                            <div 
                                                v-if="!displayInstanceToColumn" 
                                                class="instance-status"
                                            > 
                                                {{ getInstanceDeploymentStatus}}
                                            </div>
                                            <div 
                                                v-if="instance.deployment_status === 'RUNNING'"
                                                class="instance-datastore-version"
                                            >
                                                {{datastoreVersion}}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="instance.concrete_manager_url && !relatedDeploymentRequestIsRunning">
                                        <div style="display: inline-flex; align-items: center">
                                            <p class="instance-url">{{ instance.concrete_api_url }}</p>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        text
                                                        icon
                                                        small
                                                        class="copy-btn"
                                                        v-clipboard:copy="instance.concrete_api_url"
                                                        v-clipboard:success="onCopy"
                                                        v-on="on"
                                                    >
                                                        <v-icon size="15">file_copy</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    {{ !relatedDeploymentRequestIsRunning
                                                        ? $t('instance.instance_list.instance_item.copy_url')
                                                        : $t('instance.instance_list.instance_item.not_deployed')
                                                    }}
                                                </span>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                    <div class="instance-buttons">
                                        <v-btn
                                            color="info"
                                            small
                                            :disabled="!instanceIsRunning"
                                            @click="manageContent"
                                        >
                                            {{$t('instance.instance_list.instance_item.manage_btn')}}
                                            <v-icon small right>edit</v-icon>
                                        </v-btn>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    color="success"
                                                    :disabled="disabledSwaggerLink"
                                                    small
                                                    @click="openSwagger"
                                                >
                                                    {{$t('instance.instance_list.instance_item.open_api_spec')}}
                                                </v-btn>
                                            </template>
                                            <span>{{$t('instance.instance_list.instance_item.open_api_spec_tooltip')}}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    color="info"
                                                    small
                                                    @click="openInstanceDetails"
                                                >
                                                    {{$t('instance.instance_list.instance_item.open_instance_details')}}
                                                </v-btn>
                                            </template>
                                            <span>
                                                {{$t('instance.instance_list.instance_item.open_instance_details_tooltip')}}
                                            </span>
                                        </v-tooltip>
                                        <div v-if="!$store.getters.freeVersion">
                                            <v-btn
                                                v-if="!relatedDeploymentRequestIsRunning"
                                                color="info"
                                                small
                                                :disabled="relatedDeploymentRequestIsRunning || modificationRequest !== undefined"
                                                @click="openModalDeploy"
                                            >
                                                {{$t('instance.instance_list.instance_item.deploy_btn')}}
                                                <v-icon small right>open_in_browser</v-icon>
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                :disabled="true"
                                                color="info"
                                                small
                                            >
                                                <span><v-progress-circular indeterminate :width="2" :size="13"></v-progress-circular> {{ relatedDeploymentRequestProgress }}</span>
                                            </v-btn>
                                        </div>
                                        <div v-if="$store.getters.freeVersion">
                                            <v-btn
                                                color="info"
                                                small
                                                @click="openModalFreeVersion"
                                            >
                                                {{$t('instance.instance_list.instance_item.deploy_btn')}}
                                                <v-icon small right>open_in_browser</v-icon>
                                            </v-btn>
                                        </div>
                                        <waiting-button
                                            v-if="instance.deployment_status === 'RUNNING'"
                                            ref="stop-button"
                                            color="error"
                                            :text="$t('instance.instance_list.instance_item.stop_btn')"
                                            :waitingText="$t('instance.instance_list.instance_item.stopping_btn')"
                                            action="STOP"
                                            icon="stop"
                                            small
                                            :clickAction="toogleInstanceStatus"
                                            :onSuccess="instanceStatusStopSuccess"
                                            @hook:mounted="buttonMounted"
                                        >
                                        </waiting-button>
                                        <waiting-button
                                            v-if="instance.deployment_status === 'STOPPED'  && instance.concrete_manager_url !== '' &&
                                                !relatedDeploymentRequestIsRunning"
                                            ref="start-button"
                                            color="info"
                                            :text="$t('instance.instance_list.instance_item.start_btn')"
                                            :waitingText="$t('instance.instance_list.instance_item.starting_btn')"
                                            action="START"
                                            small
                                            :clickAction="toogleInstanceStatus"
                                            :onSuccess="instanceStatusStartSuccess"
                                            icon="power_settings_new"
                                            @hook:mounted="buttonMounted"
                                        ></waiting-button>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                    <modal-deploy
                        ref="modalDeploy"
                        @deploy="deploy"
                    ></modal-deploy>
                    <modal-free-version
                        v-if="freeVersion"
                        ref="modal-free-version"
                        @close-card="closeCard"
                    ></modal-free-version>
                    <dialog-notify
                        ref="deploymentSuccess" 
                        title="Instance deployed!"
                    >
                        <div slot="content">
                            <div style="display: flex; align-items: center;">
                                <v-icon color="green darken-2" style="font-size: 6em; margin-right: 10px">check_circle_outline</v-icon>
                                <p>
                                    {{$t('instance.instance_list.instance_item.is_deployed')}}
                                </p>
                            </div>
                        </div>
                    </dialog-notify>
                    <v-dialog
                        light
                        v-model="openModalInstanceDeployFailed"
                        width="500"
                        :persistent="true"
                    >
                        <v-card>
                            <v-card-title
                                class="headline"
                                primary-title
                            >
                                {{$t('instance.instance_list.instance_item.failed_deploy')}}
                            </v-card-title>
                            <v-card-text v-if="relatedDeploymentRequestStatus === 'FAILED'">
                                <p v-html="relatedDeploymentRequestVerboseStatus"></p>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    @click="closeModalDeployFailed"
                                >
                                    {{$t('instance.instance_list.instance_item.btn_close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <dialog-max-instance-reached ref="max-instance-reached"></dialog-max-instance-reached>
                    <dialog-confirm-delete
                        ref="modal-confirm-archive"
                        :title="$t('instance.instance_list.instance_item.modal_title')"
                        :text-confirm="$t('instance.instance_list.instance_item.modal_text_confirm')"
                        :text-decline="$t('instance.instance_list.instance_item.modal_text_decline')"
                        :verbose-target="$t('instance.instance_list.instance_item.verbose_target')"
                        target-model="instance"
                        :callback-confirm="archiveInstance"
                    ></dialog-confirm-delete>
                </div>
            </template>
        </ns-loader>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DialogConfirmDelete from '@/components/Partials/dialog-confirm-delete.vue';
import ModalDeploy from './modal-deploy.vue';
import ModalFreeVersion from './modal-free-version.vue';
import DialogNotify from '@/components/Partials/dialog-notify.vue';
import DialogMaxInstanceReached from '@/components/Partials/dialog-max-running-instance-reached';
import WaitingButton from '@/components/Partials/waiting-button.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import DatamodelCheckingError from '../datamodel-checking-error.vue';
import axios from 'axios';


export default {
    components: {
        ModalDeploy,
        ModalFreeVersion,
        DialogNotify,
        WaitingButton,
        NsLoader,
        DialogMaxInstanceReached,
        DatamodelCheckingError,
        DialogConfirmDelete
    },
    props: {
        application: {
            type: Object,
            required: true,
        },
        instanceUid: {
            type: String,
            required: true,
        },
        modelisations: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            freeVersion: false,
            displayDialog: false,
            showManageContentSnack: false,
            deployError: {},
            openModalInstanceDeployFailed: false,
            toLoad: [
                {
                    model: 'instances',
                    name: 'instances',
                    uid: this.instanceUid,
                },
                {
                    model: 'deploymentRequests',
                    name: 'deploymentRequest',
                    noPaginate: true,
                    //  avec ses filtres la deploymentRequest sera toujours la plus récente
                    filters: {
                        instance: this.instanceUid,
                        ordering: 'creation_Date',
                        c_resp_page_size: 1,
                        page: 1,
                    },
                },
                {
                    model: 'modificationRequests',
                    name: 'modificationRequests',
                    filters: {
                        status__in: 'RUNNING,PENDING',
                        instance_id: this.instanceUid,
                    }
                }
            ],
            modificationRequest: null,
            instance: null,
            relatedDeploymentRequest: null,
            creatingDeploymentRequest: false,
            datastoreVersion: '',
            displayDeleteBtn: true,
        };
    },
    computed: {
        ...mapGetters([
            'getWw',
            'runningInstances',
            'allowedInstances',
            'maxRunningInstancesReached',
        ]),
        instanceIsRunning (){
            return this.instance.deployment_status === 'RUNNING';
        },
        disabledSwaggerLink() {
            return (this.instanceIsRunning && this.instance.concrete_swagger_url)?false:true;
        },
        displayInstanceToColumn (){
            // 960 = md
            if( this.getWw < 960){
                return true;
            }
            return false;
        },
        hasError (){
            return this.instance.deployment_failed;
        },

        relatedDeploymentRequestProgress (){
            if(this.relatedDeploymentRequest){
                return this.$t(`instance.instance_list.instance_item.deploy_btn_launching["${this.relatedDeploymentRequest.progress||'Pending'}"]`);
            }
            return '';
        },
        relatedDeploymentRequestStatus (){
            if(this.relatedDeploymentRequest){
                return this.relatedDeploymentRequest.status;
            }
            return '';
        },
        relatedDeploymentRequestIsRunning (){
            return this.creatingDeploymentRequest ? true : ['RUNNING', 'PENDING'].includes(this.relatedDeploymentRequestStatus);
        },
        checkModelisationStatus (){
            return this.relatedDeploymentRequest ? this.relatedDeploymentRequest.check_modelisation_status : '';
        },
        getInstanceDeploymentStatus(){
            return this.$t(`instance.instance_list.instance_item.deployment_status["${this.instance.deployment_status}"]`);
        },
        relatedDeploymentRequestVerboseStatus() {
            return this.$t(`instance.instance_list.instance_item.verbose_status["${this.relatedDeploymentRequest.verbose_status}"]`, {ovhmarketplaceUrl : window.config.ovhmarketplace_url, githubUrl : window.config.github_url});
        },
        instanceStatus() {
            if(this.instance){
                return this.instance.deployment_status;
            }
            return '';
        },
    },

    watch: {
        'relatedDeploymentRequestStatus'(val, oldVal){
            if(oldVal === undefined ||oldVal === '' ) return;
            if(this.relatedDeploymentRequest.status === ['COMPLETED'] && this.relatedDeploymentRequest.check_modelisation_status === ['COMPLETED']){
                this.$refs.deploymentSuccess.open();
            }else if(this.relatedDeploymentRequest.check_modelisation_status  === 'FAILED'){
                this.$set(this, 'deployError', this.relatedDeploymentRequest.errors);
                this.openModalInstanceDeployFailed = true;
            }else if (val === 'FAILED'){
                this.$set(this, 'deployError', {
                    error: this.relatedDeploymentRequest.verbose_status,
                    error_code: 'UNKNOWN_ERROR',
                });
                this.openModalInstanceDeployFailed = true;
            }
        },
        'instanceStatus'(val, oldVal){
            if(oldVal === undefined ||oldVal === '' ) return;
            if(val === 'STOPPED'){
                this.displayDeleteBtn = true;
            }
        },
    },

    mounted (){
    },

    methods: {
        openInstanceDetails(){
            this.$eventBus.$emit('open-instance-details', this.instance);
        },
        openModalFreeVersion(){
            this.freeVersion = true;
        },
        closeCard(){
            this.freeVersion = false;
        },
        triggerEdit() {
            this.$emit('toggleDialog', this.instance);
        },
        openModalDeploy (){
            if(!this.instanceIsRunning && this.maxRunningInstancesReached){
                this.$refs['max-instance-reached'].open();
            }else{
                this.$refs.modalDeploy.init(this.application, this.instance, this.modelisations);

            }
        },
        deploy (targetModelisation){
            this.displayDeleteBtn = false;
            this.$store.dispatch('createItem', {
                item: {
                    application_uid: this.application.uid,
                    instance_uid: this.instance.uid,
                    modelisation_uid: targetModelisation,
                },
                url: this.$store.state.api.meta.listModels.deploymentRequests.url,
                model: 'deploymentRequests',
                scopes: this.$store.state.api.scopes || {},
            }).then(() => {
                this.$store.dispatch('patchItem', {
                    item: {
                        url: this.instance.url,
                        deployment_status: 'DEPLOYING'
                    },
                    model: 'instances'
                });
                this.$store.commit('SET_SNACKBAR', {
                    color: 'info',
                    icon: 'done',
                    text: this.$t('instance.instance_list.instance_item.deploy_success_text'),
                });

                this.creatingDeploymentRequest = true;
                this.$refs['ns-loader'].triggerRefresh();
            }).catch((e) => {
                console.error(e);
                this.$store.commit('SET_SNACKBAR', {
                    color: 'error',
                    icon: 'error',
                    text: this.$t('instance.instance_list.instance_item.deploy_error_text'),
                });

            }).finally(() => {
                this.$store.commit('SET_DISPLAY_SNACKBAR', true);
                this.creatingDeploymentRequest = false;
                this.$refs.modalDeploy.close();
            });
        },
        manageContent (){
            // this.showManageContentSnack = true;
            let win = window.open(this.instance.concrete_manager_url, '_blank');
            win.focus();
        },
        openSwagger (){
            let win = window.open(this.instance.concrete_swagger_url);
            win.focus();
        },
        onCopy (e){
            this.$store.commit('SET_SNACKBAR', {
                color: 'info',
                text: this.$t('instance.instance_list.instance_item.copy_text', {text : e.text})
            });
            this.$store.commit('SET_DISPLAY_SNACKBAR', true);
        },
        toogleInstanceStatus (status='START'){
            if(status === 'START' && this.maxRunningInstancesReached){
                this.$refs['max-instance-reached'].open();
            }
            this.displayDeleteBtn = false;
            this.$store.dispatch('createItem', {
                item:{
                    action: status,
                    instance_id: this.instance.uid,
                    model_name: 'instance',
                    application: this.$store.getters.getCurrentApplication.uid
                },
                url: this.$store.state.api.meta.listModels.modificationRequests.url,
                model: 'modificationRequests',
                scopes: this.$store.state.api.scopes || {},
            }).then((response) => {
                // la méthode watchRequestStatus est une méthode de la mixin du waiting button
                this.$refs[status === 'START' ? 'start-button': 'stop-button'].watchRequestStatus(response.url);
                this.$refs['ns-loader'].triggerRefresh();

            }).catch((e) => {
                console.error(e);
            });
        },
        onDataFetched (response){
            this.$set(this, 'modificationRequest', response.modificationRequests[0]);
            this.$set(this, 'instance', response.instances);
            this.$set(this, 'relatedDeploymentRequest', response.deploymentRequest[0]);
            if(this.instance.deployment_status === 'RUNNING'){
                this.getDatastoreVersion(this.instance.concrete_api_url);
            }
            if(this.relatedDeploymentRequest){
                if(this.relatedDeploymentRequest.status === 'FAILED'){
                    this.$set(this, 'deployError', {
                        message: this.relatedDeploymentRequest.verbose_status,
                        error_code : 'UNKNOWN_ERROR',
                    });
                }
                if(this.relatedDeploymentRequest.check_modelisation_status === 'FAILED'){
                    this.$set(this, 'deployError', this.relatedDeploymentRequest.errors);
                }
            }
            this.creatingDeploymentRequest = false;
        },
        buttonMounted (){
            if(this.modificationRequest){
                let status = this.modificationRequest.action;
                // la méthode watchRequestStatus est une méthode de la mixin du waiting button
                this.$refs[status === 'START' ? 'start-button': 'stop-button'].watchRequestStatus(this.modificationRequest.url);
            }

        },
        instanceStatusStartSuccess (){
            this.displaySnackbar(this.$t('instance.instance_list.instance_item.verbose_status.APP_SUCCESSFULLY_RUNNING'));
            this.$store.dispatch('fetchModelByName', 'organizationData');
        },
        instanceStatusStopSuccess (){
            this.displaySnackbar(this.$t('instance.instance_list.instance_item.verbose_status.APP_SUCCESSFULLY_STOPPED'));
            this.$store.dispatch('fetchModelByName', 'organizationData');
        },
        instanceStatusStartError (){
            this.displaySnackbar('RUNNING', true);
        },
        instanceStatusStopError (){
            this.displaySnackbar('STOPPED', true);
        },
        displaySnackbar (status, error=false){
            this.$store.commit('SET_SNACKBAR', {
                color: error ? 'error' :'success',
                icon: error ? 'error' : 'done',
                text: error
                    ? status === 'RUNNING'
                    ? this.$t('instance.instance_list.instance_item.displaySnackbar_error_start')
                    : this.$t('instance.instance_list.instance_item.displaySnackbar_error_stop')
                    : this.$t('instance.instance_list.instance_item.displaySnackbar_status', {status : status.toLowerCase()}),
            });
            this.$store.commit('SET_DISPLAY_SNACKBAR', true);
            this.$refs['ns-loader'].triggerRefresh();
        },
        closeModalDeployFailed (){
            this.openModalInstanceDeployFailed = false;
        },
        getDatastoreVersion(instanceUrl){
            let datastoreStatusUrl = new URL('/status/', instanceUrl);

            axios.get(datastoreStatusUrl).then(response=> {
                this.datastoreVersion = `Concrete Datastore v${response.data.version}`;
            });

        },
        showModalArchive(){
            this.$refs['modal-confirm-archive'].open();
        },
        archiveInstance() {
            this.$store.dispatch('patchItem', {
                item: {
                    archived: true,
                    url: this.instance.url,
                    uid: this.instance.uid,
                },
                model: 'instances'
            }).then(res => {
                this.$emit('refreshContent');
                this.$notify.success({
                    message: this.$t(
                        'instance.instance_list.instance_item.archive_notify_success',
                        {instanceLabel : this.instance.label}
                    )
                });
            }).catch(err => {
                console.error(err);
                this.$notify.error({
                    message: this.$t('instance.instance_list.instance_item.archive_notify_error')
                });
            });
        },
    },
};

</script>
<style lang="scss">
.instance-status-container{
    display: flex;
}
.instance-datastore-version{
    font-size: 12px;
    line-height: 1.3;
}
.instance-status{
    margin-right: 1rem;
}
.instance-item{
    .instance-bullet{
        width: 21px;
        height: 21px;
        border-radius: 21px;
        position: absolute;
        left: 70px;
        top: 30px;
        z-index: 5;
        cursor: pointer;

        i{
            position: absolute;
        }

        &.info{
            i{
                left: -2px;
                top: -2px;
            }
        }
        &.warning{
            border: 1px solid #fff !important;
            i{
                font-size: 15px;
                top: 2px;
                left: 2px;
            }
        }
    }

    .instance-bullet-warning.info i{
        font-size: 16px;
        position: absolute;
        left: 2px;
        top: 1px;
    }

    .instance-right-content {
        margin-bottom: 30px;

        .instance-label {
            font-size: 25px;
            margin-right: 15px
        }
        .instance-url{
            color: #deeeee;
            font-size: 14px !important;
            font-weight: 300;
            margin-right: 15px;
            margin-bottom: 0;
        }
        .copy-btn{
            margin: 0px 0px ;
        }

        .instance-buttons {
            margin-top: 10px;
            display: flex;
            .v-btn {
                margin: 0px 16px 0px 0px !important;
            }
        }
    }
    .btn-instances{
        margin-top: 1.5em;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/InstanceList/instance-item.vue